// @core/api/endpoints/attachment/transfer_ownership.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AttachmentResponse,
  TransferOwnershipRequest,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Transfer attachment ownership
 * Transfers ownership of an attachment to a new owner. Updates authorization tuples and creates an audit record with the transfer reason.
 */
export async function TransferOwnership(
  attachment_id: string,
  data: TransferOwnershipRequest,
  options?: RequestOptions
): Promise<AttachmentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/attachments/:attachment_id/transfer`;
  requestPath = requestPath.replace(':attachment_id', encodeURIComponent(attachment_id));
  const requestOptions = options;
  return client.post<AttachmentResponse>(requestPath, data, requestOptions);
}
